import { useEffect } from 'react';
import { t } from '@lingui/core/macro';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { useTutorials } from 'components/PortalTours/hooks/useTutorials.hook';
import { StandAloneCalculator } from 'components/StandAloneCalculator/StandAloneCalculator';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useSearchParams } from 'react-router-dom';
import { getCookie } from 'utils/cookieHelper';
import styles from './calculator.module.css';

export const CalculatorPage = () => {
  const [searchParams] = useSearchParams();
  const { splitTests } = useIntroducerData();

  const tourType = searchParams.get('tourType');
  const isManualTour = tourType === 'manual';
  const isAutoTour = tourType === 'auto';

  const hasAccessToPortalTours =
    getCookie('showPortalTours') ||
    splitTests?.introducer_portal_onboarding_tutorials;

  const { triggerCalculatorTour, shouldShowTour } = useTutorials({
    autoTriggered: !isManualTour,
  });

  const shouldTriggerTour =
    hasAccessToPortalTours &&
    (isManualTour || isAutoTour || shouldShowTour.calculator);

  useEffect(() => {
    if (shouldTriggerTour) {
      triggerCalculatorTour();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldTriggerTour]);

  return (
    <BaseLayout
      className={styles.container}
      pageTitle={t`Calculator | Introducer Portal`}
    >
      <StandAloneCalculator />
    </BaseLayout>
  );
};
